import {Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';

/**
 * Directive to operate with menu items
 */
@Directive({
  selector: '[menuItem]'
})
export class MenuItemDirective implements OnInit {
  @Input() isOpened: boolean = true;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {
  }

  ngOnInit(): void {
    this.setMenuItem(this.isOpened);
  }

  /**
   * Listens for the click event
   */
  @HostListener('click') toggleMenuItem(): void {
    this.isOpened = !this.isOpened;
    this.setMenuItem(this.isOpened);
  }

  /**
   * Adds or removes the class -is-open based on the provided boolean value
   */
  private setMenuItem(status: boolean): void {
    const mainEl = this.el.nativeElement;
    const siblingEl = this.renderer.nextSibling(this.el.nativeElement);
    if (status) {
      this.renderer.addClass(mainEl, '-is-open');
      this.renderer.setStyle(siblingEl, 'display', 'block');
    } else {
      this.renderer.removeClass(mainEl, '-is-open');
      this.renderer.setStyle(siblingEl, 'display', 'none');

    }
  }
}
